import { state } from '@/manager/business/store/state';
import { getters } from '@/manager/business/store/getters';
import { mutations } from '@/manager/business/store/mutations';
import { actions } from '@/manager/business/store/action';

export const business = {
    state,
    getters,
    actions,
    mutations,
};
